import { useRef } from 'react'
import { Flex } from '@mantine/core'

import { AdvisorSelect } from '@/modules/advisorsPage/components/AdvisorSelect/AdvisorSelect'
import type { AdvisorsShellProps } from '@/modules/advisorsPage/components/AdvisorsShell/AdvisorsShell.types'
import { AdvisorWorkspace } from '@/modules/advisorsPage/components/AdvisorWorkspace/AdvisorWorkspace'

import { TransactionSyncNotice } from '@/components/@Shared/TransactionSyncNotice/TransactionSyncNotice'

import classes from './AdvisorsShell.module.css'

export function AdvisorsShell({
  advisors,
  allowedAdvisors,
  isChatOpen,
  isLoading,
  isMutating,
  onChatClose,
  onChatOpen,
  onGrantAccess,
  onRevokeAccess,
  onSearchAdvisor,
  onSelectAdvisor,
  searchedAdvisor,
  selectedAdvisor,
}: AdvisorsShellProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <TransactionSyncNotice mb={24} />
      <Flex ref={containerRef} className={classes.container}>
        <AdvisorSelect
          advisors={advisors}
          allowedAdvisors={allowedAdvisors}
          isLoading={isLoading}
          onSearchAdvisor={onSearchAdvisor}
          onSelectAdvisor={onSelectAdvisor}
          searchedAdvisor={searchedAdvisor}
          selectedAdvisorId={selectedAdvisor?.id}
        />
        <Flex className={classes.chatContainer}>
          <AdvisorWorkspace
            containerRef={containerRef}
            isAdvisorAllowed={
              selectedAdvisor
                ? allowedAdvisors.includes(selectedAdvisor.id)
                : false
            }
            isChatOpen={isChatOpen}
            isMutating={isMutating}
            onChatClose={onChatClose}
            onChatOpen={onChatOpen}
            onGrantAccess={onGrantAccess}
            onRevokeAccess={onRevokeAccess}
            selectedAdvisor={selectedAdvisor}
          />
        </Flex>
      </Flex>
    </>
  )
}
